import React, { useRef } from "react";

/* An <img> for a photo in the private bucket.

   The stored photo is permanent; the URL pointing at it is not. Paths are
   signed for viewing an hour at a time, so a session left open longer than
   that ends up holding links that no longer work — the picture is still there,
   the key to it has simply gone stale. Rather than leave a hole on the screen,
   a failed load asks for a fresh link and tries again.

   Capped: a photo whose object is genuinely missing will fail however many
   links are minted for it, and retrying that forever would hammer the server
   for nothing. The counter resets on a successful load, so a picture that
   works now can still recover from an expiry hours later. */
const MAX_RESIGNS = 2;

export default function Photo({ src, onExpired, alt = "", style, fallback = null }) {
  const attempts = useRef(0);
  if (!src) return fallback;

  return (
    <img
      src={src}
      alt={alt}
      style={style}
      onLoad={() => {
        attempts.current = 0;
      }}
      onError={() => {
        if (attempts.current >= MAX_RESIGNS) return;
        attempts.current += 1;
        onExpired?.();
      }}
    />
  );
}
